const THCFields = [
  {
    id: Math.random() * 10,
    name: "Pickup_Memo_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Vendor_ID",
        label: "Vendor",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "Vendor_Account",
      },

      {
        id: Math.random() * 10,
        name: "Vehicle",
        label: "Vehicle",
        placeholder: "Vehicle",
        Reference_field: "Mode",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        masterName: "searchTransportModeData",
      },

      {
        id: Math.random() * 10,
        name: "Driver_Name",
        label: "Driver Name",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "DriverNameData",
      },
      {
        id: Math.random() * 10,
        name: "Driver_Number",
        label: "Driver Number",
        type: "number",
        min: 2,
        max: Infinity,
      },
    ],
  },
];

const THCdocs = [
  {
    id: Math.random() * 10,
    name: "Pickup_Image_1",
    label: "Pickup Image 1",
  },
  {
    id: Math.random() * 10,
    name: "Pickup_Image_2",
    label: "Pickup Image 2",
  },
  {
    id: Math.random() * 10,
    name: "Pickup_Image_3",
    label: "Pickup Image 3",
  },
];

export const THCConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "THC",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];


export const THCVoucherConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "THC",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "number",

        min: 5,
        max: 5,
      },
    ],
  },
];

const FreightCharges = [
  {
    id: Math.random() * 10,
    name: "Freight_Charges",
    fields: [
      {
        id: Math.random() * 10,
        name: "Total_Weight",
        label: "Total Weight",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Rate",
        label: "Rate",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Freight_On",
        label: "Freight On",
        type: "inputdrop",
        dropdowncontent: ["Weight", "Fixed"],
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Docket_Amount",
        label: "Docket Amount",
        value: 0,
        type: "number",
        min: 1,
        max: Infinity,
      },

      {
        id: Math.random() * 10,
        name: "Holding_Charge",
        label: "Holding Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Hamali_Charge",
        label: "Hamali Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charges",
        label: "Other Charges",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charges_Two",
        label: "Other Charges 2",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Total",
        label: "Total",
        formula: [
          { name: "Freight_Amount", opt: "+" },
          { name: "Docket_Amount", opt: "+" },
          { name: "Pickup_Charges", opt: "+" },
          { name: "Delivery_Charges", opt: "+" },
          { name: "FOV", opt: "+" },
          { name: "FSC", opt: "+" },
          { name: "Hamali_Charge", opt: "+" },
          { name: "Holding_Charge", opt: "+" },
          { name: "Other_Charges", opt: "+" },
          { name: "Other_Charges_Two", opt: "+" },
        ],
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];

export { THCFields, THCdocs, FreightCharges, };
